import { useEffect } from "react";

interface PageMeta {
  title: string;
  description?: string;
}

/**
 * Minimal SEO helper — sets document.title and updates the meta description tag.
 * react-helmet-async is not a dep here, so we update DOM nodes directly.
 * OG/Twitter tags are set statically in index.html as baseline values.
 */
export function usePageMeta({ title, description }: PageMeta) {
  useEffect(() => {
    const fullTitle = title.endsWith("VirtualDesk.ai") ? title : `${title} — VirtualDesk.ai`;
    document.title = fullTitle;

    if (description) {
      let tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = "description";
        document.head.appendChild(tag);
      }
      tag.content = description;
    }
  }, [title, description]);
}
